import dayjs from 'dayjs';

export const formatDateRange = (dateRange) => {
    if (dateRange[0] && dateRange[1]) {
        return `${dayjs(dateRange[0]).format('MMM D, YYYY')} - ${dayjs(dateRange[1]).format('MMM D, YYYY')}`;
    }
    if (dateRange[0]) {
        return `From ${dayjs(dateRange[0]).format('MMM D, YYYY')}`;
    }
    if (dateRange[1]) {
        return `Up to ${dayjs(dateRange[1]).format('MMM D, YYYY')}`;
    }
    return 'All records';
};
